<div class="flex flex-column align-items-center text-center p-7" data-cy="maintenance-page">
  <div class="w-full flex align-items-center px-4 pb-6 md:px-6">
    <img src="assets/images/my-ccs-med-logo.svg" height="46" data-cy="ccs-logo" alt="My CCS Med Logo" />
  </div>
  <img src="./assets/icons/divisional-icons/bandaid-blue.svg" height="160px" class="mb-5" />
  <h1 class="mt-0 mb-5 error-title">{{ maintenanceMessageTitle }}</h1>
  <p class="p2 mt-0 mb-4 error-message">{{ maintenanceMessage }}</p>
  <p class="p3 mt-0 mb-7 text-black-400">
    Contact us at <a href="tel:{{ ccsConfig.helpPhone }}">{{ ccsConfig.helpPhone }}</a> if you need additional support.
  </p>
</div>
